import { Checkbox } from "antd";
import React, { useState } from "react";

export default function AntCheckBox({
	item,
	activeInput,
	readOnly,
	addData,
	setSubmitData,
	submitData,
	value: controlledValue,
	onValueChange,
}) {
	const [value, setValue] = useState(false);
	const submittedValue = submitData?.find((i) => i.key === item.key)?.value;
	const rawValue = typeof onValueChange === "function" ? controlledValue : submittedValue;
	const currentValue = addData
		? rawValue === true || rawValue === "true"
		: item?.value ?? value ?? "";
	return (
		<div style={item?.css}>
			<Checkbox
				key={activeInput}
				className="form-label"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
				onChange={(e) => {
					const nextValue = e.target.checked;
					setValue(nextValue);
					if (typeof onValueChange === "function") {
						onValueChange(item.key, nextValue);
					}
					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: nextValue,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				checked={currentValue}
				value={currentValue}
				disabled={readOnly}
			>
				{item?.title}
			</Checkbox>
		</div>
	);
}
